/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * AUTO-GENERATED REACT QUERY HOOKS - DO NOT EDIT
 * Generated from: MerchantCouponsContract
 */

import { merchantcouponsApi } from '../api/merchantcoupons.api';
import { createMutationHook, createQueryHook, createPaginatedQueryHook } from './base.hooks';
import { queryKeys } from './query-keys';
import type { ListCouponsQueryType, ListCouponsParamsType, ListCouponsResponseType, GetCouponParamsType, GetCouponResponseType, CreateCouponBodyType, CreateCouponParamsType, CreateCouponResponseType } from '@zlinkx/shared-v2';
import type { HookOptions, MutationHookReturn, QueryHookReturn } from '@/types/hook-generated.types';

export const useListCoupons = createPaginatedQueryHook<ListCouponsResponseType['data'][number], { merchantId: ListCouponsParamsType['merchantId']; query?: ListCouponsQueryType }>(
  ({ merchantId, query }) => merchantcouponsApi.listCoupons(merchantId, query),
  ({ merchantId, query }) => queryKeys.merchantcoupons.listCoupons(merchantId, query)
);

export const useGetCoupon = createQueryHook<GetCouponResponseType['data'], { merchantId: GetCouponParamsType['merchantId']; couponId: GetCouponParamsType['couponId'] }>(
  ({ merchantId, couponId }) => merchantcouponsApi.getCoupon(merchantId, couponId),
  ({ merchantId, couponId }) => queryKeys.merchantcoupons.getCoupon(merchantId, couponId)
);

export const useCreateCoupon = createMutationHook<CreateCouponResponseType['data'], { merchantId: CreateCouponParamsType['merchantId']; data: CreateCouponBodyType }>(
  (params) => merchantcouponsApi.createCoupon(params.merchantId, params.data),
  {
    queryKey: queryKeys.merchantcoupons.all,
  }
);